<template>
    <div class="content-wrap">
        <resultFilter @searchForm="getSearchForm"></resultFilter>
        <div class="content">
            <div class="follow">
                <div class="content-title">
                    用户跟进
                </div>
                <div id="follow"></div>
                <div class="follow-table">
                    <div class="follow-table-top">
                        <div class="follow-table-top-item" v-for="(item, index) in arrFollowData" :key="index">
                            {{item.name}}
                        </div>
                        <!-- <div class="follow-table-top-item">丢单</div>
                        <div class="follow-table-top-item">签单</div>
                        <div class="follow-table-top-item">跟进</div> -->
                    </div>
                    <div class="follow-table-bottom">
                        <div class="follow-table-bottom-item" v-for="(item, index) in arrFollowData" :key="index">
                            <img :src="item.type === 'up' ? sUpIcon : sDownIcon" alt="">
                            <div :class="item.type === 'up' ? 'up' : 'down'">{{item.data}}%</div>
                        </div>
                        <!-- <div class="follow-table-bottom-item">
                            <img src="../../../assets/images/result/down.png" alt="">
                            <div class="down">50%</div>
                        </div>
                        <div class="follow-table-bottom-item">
                            <img src="../../../assets/images/result/up.png" alt="">
                            <div class="up">50%</div>
                        </div>
                        <div class="follow-table-bottom-item">
                            <img src="../../../assets/images/result/down.png" alt="">
                            <div class="down">50%</div>
                        </div> -->
                    </div>
                </div>
                <div class="radio-wrap">
                    <div class="radio-item">
                        <img :src="sFollowRatio === 'same' ? selectImg : noSelectImg" alt="" @click="clickRadio(0,'same')">
                        <div>同比</div>
                    </div>
                    <div class="radio-item">
                        <img :src="sFollowRatio === 'ring' ? selectImg : noSelectImg" alt="" @click="clickRadio(0,'ring')">
                        <div>环比</div>
                    </div>
                </div>
            </div>
            <div class="follow">
                <div class="content-title">
                    跟单行为
                </div>
                <div class="behave-pie-wrap">
                    <div class="behave-pie">
                        <div id="behave-pie1"></div>
                        <div>案例转发</div>
                    </div>
                    <div class="behave-pie">
                        <div id="behave-pie2"></div>
                        <div>方案书输出</div>
                    </div>
                    <div class="behave-pie">
                        <div id="behave-pie3"></div>
                        <div>三维设计输出</div>
                    </div>
                </div>
                <div id="behave"></div>
                <div class="follow-table behave-table">
                    <div class="follow-table-top">
                        <div class="follow-table-top-item">案例转发</div>
                        <div class="follow-table-top-item">方案书输出</div>
                        <div class="follow-table-top-item">三维设计输出</div>
                    </div>
                    <div class="follow-table-bottom">
                        <div class="follow-table-bottom-item" v-for="(item, index) in arrBehaviorData" :key="index">
                            <img :src="item.type === 'up' ? sUpIcon : sDownIcon" alt="">
                            <div :class="item.type === 'up' ? 'up' : 'down'">{{item.data}}%</div>
                            <!-- <img src="../../../assets/images/result/up.png" alt="">
                            <div class="up">50%</div> -->
                        </div>
                        <!-- <div class="follow-table-bottom-item">
                            <img src="../../../assets/images/result/down.png" alt="">
                            <div class="down">50%</div>
                        </div>
                        <div class="follow-table-bottom-item">
                            <img src="../../../assets/images/result/up.png" alt="">
                            <div class="up">50%</div>
                        </div> -->
                    </div>
                </div>
                <div class="radio-wrap" style="border: none">
                    <div class="radio-item">
                        <img :src="sBehaviorRatio === 'same' ? selectImg : noSelectImg" alt="" @click="clickRadio(1,'same')">
                        <div>同比</div>
                    </div>
                    <div class="radio-item">
                        <img :src="sBehaviorRatio === 'ring' ? selectImg : noSelectImg" alt="" @click="clickRadio(1,'ring')">
                        <div>环比</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import resultFilter from '@/components/hvac/performance/project/resultfilter.vue'
import oDocumentaryJs from "@/js/hvac/performance/result.js"

export default {
    name: "documentary",
    components: {
        resultFilter
    },
    created() {
        $init(() => {
            //Promise.all([this.getFollowOrder()]).then((res) => {})
        })
    },
    data() {
        return {
            // isFollow: 'tb',
            // isBehave: 'tb',
            selectImg: require('@/assets/images/result/select.png'),
            noSelectImg: require('@/assets/images/result/noSelect.png'),
            sUpIcon: require("@/assets/images/result/up.png"),
            sDownIcon: require("@/assets/images/result/down.png"),
            //搜索表单
            oSearchForm: {
                //...
                agent: "",
                area: "",
                channel: "",
                city: "",
                worker: "",
                start: "",
                end: ""
            },
            //用户跟进
            oFollowCharts: null,
            arrFollowBarX: [],
            arrFollowBarY: [],
            sFollowRatio: "same",
            //用户跟进下面的数据
            arrFollowData: [],
            //跟单行为
            sBehaviorRatio: "same",
            arrBehaviorPie: [0, 0, 0],
            oBehaviorPie1: null,
            oBehaviorPie2: null,
            oBehaviorPie3: null,
            oBehaviorBar: null,
            arrBehaviorBarX: [],
            arrBehaviorBarY: [],
            arrBehaviorData: []
        }
    },
    mounted() {
        setTimeout(() => {
            this.createFollowCharts()
            this.createBehaveCharts()
            this.createBehavePie1()
            this.createBehavePie2()
            this.createBehavePie3()
        }, 500)
    },
    methods: {
        //用户跟进条形图
        createFollowCharts() {
            if (this.oFollowCharts != null &&
                this.oFollowCharts != "" &&
                this.oFollowCharts != undefined) {
                this.oFollowCharts.dispose();
            }
            let arrSeries = []
            this.arrFollowBarY.forEach((item, index) => {
                arrSeries.push({
                    name: item.name,
                    data: item.data,
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'right',
                        textStyle: {
                            fontSize: 14,
                            color: '#A2A2A2'
                        }
                    },
                })
            })

            this.oFollowCharts = this.$echarts.init(document.getElementById("follow"));
            const OPTIONS = {
                color: ['rgba(91, 143, 249, 0.85)', 'rgba(90, 216, 166, 0.85)'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                //不显示原因待查
                 legend: {
                //     //show: true,
                 },
                grid: {
                    left: '1%',
                    right: '4%',
                    bottom: '3%',
                    top: '20%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    show: false,
                    splitLine: {
                        show: true
                    }
                },
                yAxis: {
                    type: 'category',
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            fontSize:14,
                            color: 'rgba(0, 0, 0, 0.15)'
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            fontSize:14,
                            color: 'rgba(0, 0, 0, 0.45)'
                        }
                    },
                    data: this.arrFollowBarX//['上线', '丢单', '签单', '跟进']
                },
                series: arrSeries
            };
            this.oFollowCharts.setOption(OPTIONS)
        },
        createBehaveCharts() {
            if (this.oBehaviorBar != null &&
                this.oBehaviorBar != "" &&
                this.oBehaviorBar != undefined) {
                this.oBehaviorBar.dispose();
            }

            let arrSeries = []
            this.arrBehaviorBarY.forEach(item => {
                arrSeries.push({
                    name: item.name,
                    data: item.data,
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'right',
                        textStyle: {
                            fontSize: 14,
                            color: '#A2A2A2'
                        }
                    },
                })
            })

            this.oBehaviorBar = this.$echarts.init(document.getElementById("behave"));
            const OPTIONS = {
                color: ['rgba(91, 143, 249, 0.85)', 'rgba(90, 216, 166, 0.85)'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {

                },
                grid: {
                    left: '1%',
                    right: '4%',
                    bottom: '3%',
                    top: '20%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    show: false,
                    splitLine: {
                        show: true
                    }
                },
                yAxis: {
                    type: 'category',
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            fontSize:14,
                            color: 'rgba(0, 0, 0, 0.15)'
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            fontSize:14,
                            color: 'rgba(0, 0, 0, 0.45)'
                        }
                    },
                    data: this.arrBehaviorBarX
                },
                series: arrSeries
            };
            this.oBehaviorBar.setOption(OPTIONS)
        },
        createBehavePie1() {
            if (this.oBehaviorPie1 != null &&
                this.oBehaviorPie1 != "" &&
                this.oBehaviorPie1 != undefined) {
                this.oBehaviorPie1.dispose();
            }
            this.oBehaviorPie1 = this.$echarts.init(document.getElementById("behave-pie1"));
            const OPTIONS = {
                // tooltip: {
                //     trigger: 'item'
                // },
                color: ['rgba(91, 143, 249, 0.85)', '#F1F1F1'],
                series: [
                    {
                        name: '案例转发',
                        type: 'pie',
                        radius: ['60%', '100%'],
                        hoverAnimation: false,
                        avoidLabelOverlap: false,
                        silent:true,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        // emphasis: {
                        //     label: {
                        //         show: false,
                        //         fontSize: '22',
                        //         fontWeight: 'bold'
                        //     }
                        // },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: this.arrBehaviorPie[0], label: { show: true, formatter: '{d}%', textStyle: { color: '#252525', fontSize: '22', fontWeight: 'bold' } } },
                            { value: 100 - this.arrBehaviorPie[0], label: { show: false } }
                        ]
                    }
                ]
            };
            this.oBehaviorPie1.setOption(OPTIONS)
        },
        createBehavePie2() {
            if (this.oBehaviorPie2 != null &&
                this.oBehaviorPie2 != "" &&
                this.oBehaviorPie2 != undefined) {
                this.oBehaviorPie2.dispose();
            }
            this.oBehaviorPie2 = this.$echarts.init(document.getElementById("behave-pie2"));
            const OPTIONS = {
                // tooltip: {
                //     trigger: 'item'
                // },
                color: ['rgba(249, 178, 91, 0.85)', '#F1F1F1'],
                series: [
                    {
                        name: '方案书输出',
                        type: 'pie',
                        radius: ['60%', '100%'],
                        hoverAnimation: false,
                        avoidLabelOverlap: false,
                        silent:true,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: this.arrBehaviorPie[1], label: { show: true, formatter: '{d}%', textStyle: { color: '#252525', fontSize: '22', fontWeight: 'bold' } } },
                            { value: 100 - this.arrBehaviorPie[1] }
                        ]
                    }
                ]
            };
            this.oBehaviorPie2.setOption(OPTIONS)
        },
        createBehavePie3() {
            if (this.oBehaviorPie3 != null &&
                this.oBehaviorPie3 != "" &&
                this.oBehaviorPie3 != undefined) {
                this.oBehaviorPie3.dispose();
            }
            this.oBehaviorPie3 = this.$echarts.init(document.getElementById("behave-pie3"));
            const OPTIONS = {
                // tooltip: {
                //     trigger: 'item'
                // },
                color: ['#EB6F56', '#F1F1F1'],
                series: [
                    {
                        name: '三维设计输出',
                        type: 'pie',
                        radius: ['60%', '100%'],
                        hoverAnimation: false,
                        avoidLabelOverlap: false,
                        silent:true,
                        label: {
                            show: false,
                            position: 'center',
                            fontSize: '22',
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '22',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false,
                        },
                        data: [
                            {
                                value: this.arrBehaviorPie[2],
                                label: {
                                    show: true, formatter: '{d}%',
                                    textStyle: { color: '#252525', fontSize: '22', fontWeight: 'bold' }
                                },
                            },
                            { value: 100 - this.arrBehaviorPie[2] }
                        ]
                    }
                ]
            };
            this.oBehaviorPie3.setOption(OPTIONS)
        },
        //用户跟进
        getFollowOrder() {
            let data = {
                agent: this.oSearchForm.agent,
                area: this.oSearchForm.area,
                channel: this.oSearchForm.channel,
                city: this.oSearchForm.city,
                worker: this.oSearchForm.worker,
                start: this.oSearchForm.start,
                end: this.oSearchForm.end,
                ratio: this.sFollowRatio
            }
            oDocumentaryJs.getFollowOrder(data).then(res => {
                let result = res.data.data.result;
                //console.log(result.series.series)
                this.arrFollowBarX = result.series.data;
                this.arrFollowBarY = result.series.series;
                this.arrFollowData = result.data;
                this.createFollowCharts()
            })
        },
        //跟单行为
        getFollowBehavior() {
            let data = {
                agent: this.oSearchForm.agent,
                area: this.oSearchForm.area,
                channel: this.oSearchForm.channel,
                city: this.oSearchForm.city,
                worker: this.oSearchForm.worker,
                start: this.oSearchForm.start,
                end: this.oSearchForm.end,
                ratio: this.sBehaviorRatio
            }
            oDocumentaryJs.getFollowBehavior(data).then(res => {
                let result = res.data.data.result;
                this.arrBehaviorPie = result.circle;
                this.arrBehaviorPie.forEach((item, index) => {
                    this.arrBehaviorPie[index] = Number(item.value)
                })
                this.arrBehaviorBarX = result.series.data;
                this.arrBehaviorBarY = result.series.series;
                this.arrBehaviorData = result.data;
                this.createBehavePie1()
                this.createBehavePie2()
                this.createBehavePie3()
                this.createBehaveCharts()
            })
        },
        //同比环比 点击事件
        clickRadio(type, ratio) {
            switch (type) {
                case 0:
                    if (this.sFollowRatio != ratio) {
                        this.sFollowRatio = ratio;
                        this.getFollowOrder();
                    }
                    break;
                case 1:
                    if (this.sBehaviorRatio != ratio) {
                        this.sBehaviorRatio = ratio;
                        this.getFollowBehavior();
                    }
                    break
            }
        },
        getSearchForm(val) {
            //console.log("getSearchForm")
            this.oSearchForm = val
            this.getFollowOrder()
            this.getFollowBehavior()
        }
    }
}
</script>

<style lang="scss" scoped>
.content-wrap {
    background: #f0f4f1;

    .content {
        width: 93.6%;
        margin: 24px auto 48px;
        background: #ffffff;
        border-radius: 12px;
        padding: 0 24px;

        .content-title {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #222222;
            line-height: 100px;
        }

        .follow {
            #follow,
            #behave {
                width: 100%;
                height: 500px;
            }

            .behave-pie-wrap {
                width: 100%;
                display: flex;
                border-bottom: 2px dashed #f1f1f1;
                justify-content: space-between;

                .behave-pie {
                    width: 28.3%;

                    #behave-pie1,
                    #behave-pie2,
                    #behave-pie3 {
                        width: 100%;
                        height: 200px;
                    }
                    div {
                        font-size: 24px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        text-align: center;
                        color: #858585;
                        line-height: 78px;
                    }
                }
            }

            .follow-table {
                width: 100%;
                .follow-table-top {
                    display: flex;
                    align-items: center;
                    background: #318544;
                    border-radius: 12px 12px 0 0;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    text-align: center;
                    color: #ffffff;
                    line-height: 70px;

                    .follow-table-top-item {
                        width: 24.8%;
                        border-right: 2px solid rgba(255, 255, 255, 0.15);

                        &:last-child {
                            border-right: none;
                        }
                    }
                }

                .follow-table-bottom {
                    display: flex;
                    align-items: center;
                    border: 2px solid #6c9276;
                    border-top: none;

                    .follow-table-bottom-item {
                        width: 24.8%;
                        border-right: 2px solid #6c9276;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 32px;
                            height: 32px;
                            margin-right: 12px;
                        }

                        div {
                            font-size: 28px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #318544;
                            line-height: 70px;
                        }

                        .up {
                            color: #318544;
                        }
                        .down {
                            color: #eb6f56;
                        }

                        &:last-child {
                            border: none;
                        }
                    }
                }
            }
            .behave-table {
                .follow-table-top-item {
                    width: 33.3% !important;
                }
                .follow-table-bottom-item {
                    width: 33.3% !important;
                }
            }

            .radio-wrap {
                display: flex;
                padding: 30px 0;
                border-bottom: 2px dashed #f1f1f1;
                justify-content: space-around;
                align-items: center;

                .radio-item {
                    display: flex;
                    align-items: center;
                    img {
                        width: 36px;
                        height: 36px;
                        margin-right: 8px;
                    }

                    div {
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #444444;
                        line-height: 40px;
                    }
                }
            }
        }
    }
}
</style>